import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import router from '@/router';

const TOKEN_KEY = '@donativa/token';
const EXP_KEY = '@donativa/expirationDate';

const auth = {
    namespaced: true,
    state: {
        user: {},
        token: window.localStorage.getItem(TOKEN_KEY) || null,
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
        },
        CLEAR_AUTH(state) {
            state.token = null;
            state.user = {};
        },
    },
    actions: {
        login({ commit }, token) {
            commit('SET_TOKEN', token);
            const { exp } = jwtDecode(token);
            const expirationDate = exp * 1000;
            window.localStorage.setItem(TOKEN_KEY, token);
            window.localStorage.setItem(EXP_KEY, String(expirationDate));

            // axios.defaults.headers.common.Authorization = `Bearer ${token}`;

            router.push({ name: 'main.home' });
        },

        async logout({ commit }) {
            try {
                // 1) zera axios
                delete axios.defaults.headers.common.Authorization;

                // 2) limpa storages
                window.localStorage.removeItem(TOKEN_KEY);
                window.localStorage.removeItem(EXP_KEY);
                sessionStorage.clear();

                // 3) limpa caches (resolve “só funciona em aba anônima” se tiver SW/cache)
                if (window.caches && caches.keys) {
                    const names = await caches.keys();
                    await Promise.all(names.map(n => caches.delete(n)));
                }

                // 4) desregistra qualquer service worker
                if ('serviceWorker' in navigator) {
                    const regs = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(regs.map(r => r.unregister()));
                }

                // 5) reseta estado
                commit('CLEAR_AUTH');
            } finally {
                // 6) redireciona “frio” (evita bfcache/SPA em memória)
                // router.push({ name: 'auth.login' });
                // se preferir por nome de rota:
                window.location.replace(
                    router.resolve({ name: 'auth.login' }).href,
                );
            }
        },

        async validateToken({ state, dispatch }) {
            // fallback pro primeiro load
            const token = state.token || window.localStorage.getItem(TOKEN_KEY);
            if (!token) return false;

            try {
                const { exp } = jwtDecode(token);
                const now = Math.floor(Date.now() / 1000);

                // margem de 30s para evitar corrida
                if (exp - 30 <= now) {
                    await dispatch('logout');
                    return false;
                }

                // garante header após refresh da página
                if (!axios.defaults.headers.common.Authorization) {
                    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                }

                return true;
            } catch (error) {
                await dispatch('logout');
                console.error(error);
                return false;
            }
        },
    },
    getters: {
        isLogged(state) {
            return !!state.token;
        },
    },
};

export default auth;
